module.exports = __webpack_public_path__ + "static/edit-social-media-icons-08ed37d0f840e31f346bcd46103284a2.png";